import { FC } from "react";
import Badge from "../Badge";
import ReactCountryFlag from "react-country-flag/dist";

interface FreelancerProps {
  name: string;
  job: string;
  country: string;
  countryCode: string;
  countryColor: string;
  experience: number;
  stars: number;
  cost: number;
  duration: string;
  start: string;
  image: string;
  skills: JSX.Element;
}

const Freelancer: FC<FreelancerProps> = ({
  name,
  job,
  country,
  countryCode,
  experience,
  stars,
  cost,
  start,
  duration,
  image,
  skills,
  countryColor,
}) => {
  return (
    <div className="border-[1.5px] border-[#DBE0F6] rounded-2xl relative xl:col-span-4 lg:col-span-6 col-span-12">
      <div className="border-b-[1.5px] border-[#DBE0F6] grid grid-cols-12 gap-3 p-5">
        <div className="col-span-5 flex justify-center items-center">
          <img
            src={image}
            alt="freelancer"
            width={500}
            height={500}
            className="rounded-full w-[90%] h-auto object-contain"
          />
        </div>
        <div className="col-span-7 flex flex-col justify-center items-start">
          <h4 className="text-lg font-bold text-black mb-2">{name} </h4>
          <p className="font-semibold text-base text-[#8F95B2] mb-2">{job}</p>
          <div className="flex gap-2 mb-3 items-center">
            <img
              alt="wallet icon"
              src="/icons/calendar-simple.svg"
              width={20}
              height={20}
            />
            <span className="text-sm text-[#6563a9b3] font-bold  ">
              Experience
            </span>
            <Badge classColor="progress-black" size="xs">
              {experience} years
            </Badge>
          </div>
          <div className="flex xl:flex-row flex-col items-center">
            <span className="text-base font-bold tracking-wide text-black inputoutput">
              Review
            </span>
            <div className="flex gap-1 ml-2">
              {Array.from(Array(stars).keys()).map((_, index) => (
                <img
                  key={index}
                  alt="wallet icon"
                  src="/icons/star.svg"
                  width={20}
                  height={20}
                />
              ))}
            </div>
          </div>
        </div>
      </div>
      <div className="p-5 grid grid-cols-12 gap-3 gap-y-5">
        <div className="col-span-12">
          <h5 className="text-base text-[#00000080] font-bold mb-2 inputoutput">
            Skills
          </h5>
          <div className="flex basis-full gap-3 flex-wrap font-bold inputoutput text-sm">
            {skills}
          </div>
        </div>
        <div className="col-span-4 flex flex-col justify-stretch items-center gap-2 border-[1.5px] border-[#DBE0F6] rounded-2xl py-2">
          <img
            alt="wallet icon"
            src="/icons/wallet.svg"
            width={30}
            height={30}
          />
          <span className="text-[#6563a9b3] font-bold inputoutput text-sm">
            Cost
          </span>
          <strong className="text-[#081735] font-bold inputoutput text-base">
            {cost}
          </strong>
        </div>
        <div className="col-span-4 flex flex-col justify-stretch items-center gap-2 border-[1.5px] border-[#DBE0F6] rounded-2xl py-2">
          <img
            alt="wallet icon"
            src="/icons/clock.svg"
            width={30}
            height={30}
          />
          <span className="text-[#6563a9b3] font-bold inputoutput text-sm">
            Delivery time
          </span>
          <strong className="text-[#081735] font-bold inputoutput text-base">
            {duration}
          </strong>
        </div>
        <div className="col-span-4 flex flex-col justify-stretch items-center gap-2 border-[1.5px] border-[#DBE0F6] rounded-2xl py-2">
          <img
            alt="wallet icon"
            src="/icons/calendar.svg"
            width={30}
            height={30}
          />
          <span className="text-[#6563a9b3] font-bold inputoutput text-sm">
            Start dev
          </span>
          <strong className="text-[#081735] font-bold inputoutput text-base">
            {start}
          </strong>
        </div>
      </div>
      <div
        className={`absolute top-1 right-1 ${countryColor} rounded-3xl px-2 py-[3px] flex items-center`}
      >
        <ReactCountryFlag
          className="rounded-full w-5 h-5 mr-2"
          countryCode={countryCode}
          svg
        />
        <span className="font-semibold text-sm text-black">{country}</span>
      </div>
    </div>
  );
};

export default Freelancer;
